import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { MatMenuTrigger } from '@angular/material/menu'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Router } from '@angular/router'
// import { ActivatedRoute, Params } from '@angular/router'
import { AlertService } from '@app/alert/service/alert.service'
import { ModalService } from '@app/modal/modal.service'
import { VinculoInstituicaoService } from '@shared/components/vinculo-instituicao/vinculo-instituicao-service'
import { InstituicaoModel, TipoComissaoDomainModel, VinculoInstituicaoModel } from '@shared/models/backend'
import { CnpjPipe } from '@widgets/pipes/cnpj/cnpj.pipe'
import { CpfPipe } from '@widgets/pipes/cpf/cpf.pipe'
import { merge } from 'rxjs'
import { map, startWith, switchMap } from 'rxjs/operators'
// import { VinculoInstituicaoService } from '../vinculo-instituicao-service'

@Component({
  selector: 'app-vinculo-table',
  templateUrl: './vinculo-table.component.html',
  styleUrls: ['./vinculo-table.component.scss'],
  providers: [CpfPipe, CnpjPipe],
})
export class VinculoTableComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger
  @Input() instituicao: InstituicaoModel

  filterChange: EventEmitter<string> = new EventEmitter()
  dataSource = new MatTableDataSource<VinculoInstituicaoModel>()
  displayedColumns = []

  constructor(
    private router: Router,
    private vinculoInstituicaoService: VinculoInstituicaoService,
    private modalService: ModalService,
    private alertService: AlertService,
    private cpfPipe: CpfPipe,
    private cnpjPipe: CnpjPipe
  ) {}

  ngOnInit(): void {
    this.displayedColumns = ['tipoComissao', 'cpf', 'nomeCoordenador', 'actions']

    this.dataSource.data = this.instituicao.vinculos
  }

  confirmarDesvinculacaoCoordenador(vinculoInstituicao: VinculoInstituicaoModel): void {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.data = {
      title: 'Deseja remover o acesso do(a) coordenador(a) da comissão?',
      message: `Após confirmar, o coordenador de CPF ${this.cpfPipe.transform(vinculoInstituicao?.coordenadorCpf)}
         não terá mais acesso ao sistema como coordenador ${vinculoInstituicao?.comissaoTipo?.sigla} da instituição
         ${this.instituicao?.razaoSocial} do CNPJ
         ${this.cnpjPipe.transform(this.instituicao?.cnpj)}
         e a comissão ficará sem coordenador.`,
      primaryOption: 'REMOVER',
      secondaryOption: 'CANCELAR',
      primaryOptionColor: 'warn',
    }

    dialogConfig.width = '26em'

    const modalRefComponent = this.modalService.openConfirmModal(dialogConfig)
    modalRefComponent.afterClosed().subscribe((hasConfirmed: boolean) => {
      if (hasConfirmed) {
        this.vinculoInstituicaoService.removerVinculoInstituicao(vinculoInstituicao?.vinculoInstituicaoId).subscribe(
          (_) => {
            this.alertService.showSuccess('Coordenador de comissão removido com sucesso')
          },
          (_) => {
            this.alertService.showError('Houve um erro ao desvincular o coordenador da instituição')
          },
          () => {
            this.filterChange.emit()
          }
        )
      }
    })
  }

  onClickEditarComissao(vinculo: VinculoInstituicaoModel) {
    let instituicaoId = this.instituicao.id
    let comissaoId = vinculo.comissao.id

    this.router.navigateByUrl(`instituicao/${instituicaoId}/comissao/editar/${comissaoId}`)
  }
}
